import { render, staticRenderFns } from "./KillfeedItem.vue?vue&type=template&id=6ff42499&scoped=true&"
import script from "./KillfeedItem.vue?vue&type=script&lang=js&"
export * from "./KillfeedItem.vue?vue&type=script&lang=js&"
import style0 from "./KillfeedItem.vue?vue&type=style&index=0&id=6ff42499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff42499",
  null
  
)

export default component.exports